module.exports = __webpack_public_path__ + "img/checklist-kejarcuan.2f6e72ef.svg";